import { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import "./affiliate-auth.css";

export default function AffiliateLogin() {
  const navigate = useNavigate();
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [msg,setMsg] = useState("");
  const [loading,setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setMsg("Invalid login");
      setLoading(false);
      return;
    }

    const { data: aff } = await supabase
      .from("affiliates")
      .select("id")
      .eq("id", data.user.id)
      .single();

    if (!aff) {
      navigate("/affiliate/signup");
      return;
    }

    navigate("/affiliate/dashboard");
    setLoading(false);
  };

  return (
    <div className="aff-auth-wrapper">
      <form className="aff-auth-box" onSubmit={submit}>
        <h2>Affiliate Login</h2>
        {msg && <div className="aff-auth-msg">{msg}</div>}

        <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="Email" required />
        <input value={password} onChange={e=>setPassword(e.target.value)} type="password" placeholder="Password" required />

        <button disabled={loading}>{loading ? "Please wait..." : "Login"}</button>

        <div className="aff-auth-footer">
          No account? <span onClick={()=>navigate("/affiliate/signup")}>Signup</span>
        </div>
      </form>
    </div>
  );
}
